import React, { Component } from 'react';
import { createComponent as cc } from 'react-fela';
import { Sort } from '@material-ui/icons';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import { Paper } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const SortingComponentWrapper = cc(() => ({
  position: 'fixed',
  bottom: '20px',
  right: '20px',
  zIndex: '3000',
}));

const ModalWindowContentWrapper = cc(() => ({
  position: 'absolute',
  width: '300px',
  top: '300px',
  left: 'calc(50% - 150px)',
}));

class SortingComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sortingModalVisible: false,
    };
  }

  handleClose = () => {
    this.setState({ sortingModalVisible: false });
  };

  handleButtonClick = () => {
    this.setState({ sortingModalVisible: !this.state.sortingModalVisible });
  };

  render() {
    return (
      <SortingComponentWrapper>
        <Button
          variant="fab"
          color="primary"
          aria-label="Sorting"
          onClick={this.handleButtonClick}
        >
          <Sort />
        </Button>
        <Modal open={this.state.sortingModalVisible} onClose={this.handleClose}>
          <ModalWindowContentWrapper>
            <Paper>
              <List component="nav">
                <ListItem>
                  <ListItemText primary="Newest first" />
                </ListItem>
              </List>
            </Paper>
          </ModalWindowContentWrapper>
        </Modal>
      </SortingComponentWrapper>
    );
  }
}

export default SortingComponent;



// WEBPACK FOOTER //
// ./src/components/feedback/SortingComponent.js